import { opacity, Token } from '@revolut-internal/ui-kit'

const HEAT_MAP_MAX_VALUE = 60
const HEAT_MAP_THRESHOLD = 5
const HEAT_MAP_LENGTH = HEAT_MAP_MAX_VALUE / HEAT_MAP_THRESHOLD + 1

const heatMapColors = [
  opacity(Token.colorChannel.orange, 0.1),
  ...Array.from({ length: HEAT_MAP_LENGTH }, (_, index) =>
    opacity(
      Token.colorChannel.teal,
      Number(((1 / (HEAT_MAP_LENGTH - 1)) * index).toFixed(2)),
    ),
  ),
]

export const getPositiveHeatMapColor = (value: number) => {
  const heatMapIndex = value === 0 ? 0 : Math.floor(value / HEAT_MAP_THRESHOLD) + 1

  return heatMapColors[heatMapIndex <= HEAT_MAP_LENGTH ? heatMapIndex : HEAT_MAP_LENGTH]
}
